import style from './style.module.css';
import CalcDesc from '@components/CalcDesc';
import Container from '@components/Container';
import Header from '@components/Header';
import AccountCard from '@components/AccountCard';
import Footer from '@components/Footer';

const AccountsPage = () => {
    // Создаем данные для тренировок в формате, понятном AccountCard
    const trainings = [
        {
            id: 1,
            name: "Полный Курс Тренировок",
            description: "Полная база на всех картах офф мап пула, Разбор демо, Мувмент (индивидуальный подход)",
            price: 9999,
            type: "training",
            hours: "Включает все карты",
            rank: "Курс: Профессиональный",
            images: '/img/full-course.jpg'
        },
        {
            id: 2,
            name: "Стандартная тренировка",
            description: "Карта на ваш выбор, Раскид гранат, Мувмент, Стрельба",
            price: 1199,
            type: "training",
            hours: "1 сессия",
            rank: "Курс: Стандарт",
            images: '/img/default-traning.jpg'
        },
        {
            id: 3,
            name: "Разбор демо",
            description: "Полный анализ вашей игры, Помощь в понимании игры, Как разбирать свои демки",
            price: 750,
            type: "training",
            hours: "Анализ 1 игры",
            rank: "Курс: Аналитический",
            images: '/img/analyses-demo.jpg'
        },
        {
            id: 4,
            name: "Обучение Мувмент",
            description: "𝐁𝐇𝐎𝐏, 𝐊𝐙, 𝐒𝐔𝐑𝐅",
            price: 1199,
            type: "training",
            hours: "Интенсивный курс",
            rank: "Курс: Продвинутый",
            images: '/img/teach-movement.jpg'
        },
        {
            id: 5,
            name: "Обучение Стрельба",
            description: "𝐀𝐈𝐌, 𝐒𝐏𝐑𝐀𝐘, 𝐓𝐀𝐏𝐏𝐈𝐍𝐆",
            price: 1199,
            type: "training",
            hours: "Точность и контроль",
            rank: "Курс: Тактический",
            images: '/img/teach.jpg'
        },
        {
            id: 6,
            name: "Помощь в Сетапе",
            description: "Подборка комфортных условий, Настройка видео, Настройка сенсы, Настройка прицела, Бинды, КФГ",
            price: 500,
            type: "training",
            hours: "Персонализация",
            rank: "Курс: Базовый",
            images: '/img/course-settings.jpg'
        }
    ];

    return (
        <div className={style.accounts_page}>
            <Header type="mini" />
            <div className={style.accounts_page__desc}>
                <CalcDesc
                    title={`Профессиональные тренировки по CS2`}
                    desc={`Улучшите свои навыки игры с нашими профессиональными тренерами`}
                />
            </div>
            <Container>
                <div className={style.accounts_page__container}>
                    {trainings.map((training) => (
                        <AccountCard data={training}/>
                    ))}
                </div>
            </Container>
            <Footer type="mini"/>
        </div>
    );
};

export default AccountsPage;